import { Component, CustomElement } from "../../core/CustomElement";

// Interfaces.
import Discussion from "../../core/interfaces/Discussion";

// Utilities.
import { validateJsonStringified } from "../../core/utilities";

// Components to use.
import "../discussion-detail/discussionDetail";
import CCCDiscussionDetail from "../discussion-detail/discussionDetail";

@Component("ccc-discussion-list", {
  template: require("./discussionList.html").default,
  style: require("./discussionList.scss").default,
  observedAttributes: ["discussions"],
})
export default class CCCDiscussionList extends CustomElement {
  getDiscussion: (discussionId: number) => Promise<Discussion>;

  constructor() {
    super();
  }

  attributeChangedCallback(
    attr: string,
    _oldValue: string,
    newValue: string
  ): void {
    if (attr === "discussions") {
      const discussions: Array<Discussion> = validateJsonStringified(newValue);
      if (discussions) {
        this.discussions = discussions;
      } else {
        this.discussions = null;
      }
    }
  }

  public set discussions(value: Array<Discussion>) {
    const $discussionList = this.shadowDom.querySelector(
      "#discussionContainer"
    );
    while ($discussionList.firstChild) {
      $discussionList.removeChild($discussionList.firstChild);
    }
    value.forEach((discussion) => {
      const $discussion = <CCCDiscussionDetail>(
        document.createElement("ccc-discussion-detail")
      );
      $discussion.id = discussion.discussionId.toString();
      $discussion.classList.add("discussion");
      $discussion.onLoad(this.getDiscussion);
      $discussion.discussion = discussion;
      $discussionList.append($discussion);
    });
  }

  public onDiscussionLoad(
    getDiscussion: (discussionId: number) => Promise<Discussion>
  ): void {
    this.getDiscussion = getDiscussion;
  }
}
